export const HIGH_IMPACT_PACKAGE_PERMISSION = 'HIGH_IMPACT_PACKAGE_PERMISSION';

export const NO_HIP_TARGETING_ID = -1;

const HIGH_IMPACT_PACKAGE_OPTIONS = {
    HIGH_IMPACT_PACKAGE: 'High Impact Package',
};

export default HIGH_IMPACT_PACKAGE_OPTIONS;
